import React from 'react';

export const name = 'flag-DK';

export const FlagDK = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_120)">
      <mask
        id="mask0_2_120"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_120)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M9.38906 10.4344H23.8969C23.517 7.54795 22.1008 4.89806 19.9121 2.97836C17.7233 1.05868 14.9113 0.000157227 12 2.28048e-05C11.122 -0.00168584 10.2465 0.092625 9.38906 0.281273V10.4344ZM6.2625 10.4344V1.45784C4.60137 2.36318 3.17761 3.64817 2.10725 5.20809C1.03688 6.76805 0.350198 8.55877 0.103134 10.4344H6.2625ZM6.2625 13.5656H0.103134C0.350198 15.4413 1.03688 17.232 2.10725 18.792C3.17761 20.3519 4.60137 21.6368 6.2625 22.5422V13.5656ZM9.38906 13.5656V23.7141C10.2464 23.9043 11.1219 24.0002 12 24C14.9113 23.9999 17.7233 22.9414 19.9121 21.0217C22.1008 19.102 23.517 16.4521 23.8969 13.5656H9.38906Z"
          fill="#D80027"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_120">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
